import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # NasVol
 *
 * NasVol을 설명하세요.
 */
export const NasVol = types
  .model('NasVol')
  // --------------------------------------------------------------------------
  .props({
    nasVolSid: types.identifierNumber,
    nasVolNm: types.optional(types.string, ''), // 볼륨명
    subnetInfo: types.maybeNull(types.optional(types.string, '')), // subnet
    totSize: types.maybeNull(types.string), // 전체용량
    useSize: types.maybeNull(types.string), // 사용량
    protocolInfo: types.maybeNull(types.optional(types.string, '')), // protocol
    mountPath: types.maybeNull(types.optional(types.string, '')), // mount path

    useYn: types.maybeNull(types.optional(types.string, 'Y')),
    delYn: types.maybeNull(types.optional(types.string, 'N')),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model nasVol --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: INasVol }) => {
      const newProps = { ...self, ...props } as INasVol;
      (Object.keys(newProps) as TNasVolKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TNasVol = Instance<typeof NasVol>;
type TNasVolSnapshot = SnapshotOut<typeof NasVol>;

export interface INasVol extends TNasVol {}
export type TNasVolKeys = keyof TNasVolSnapshot & string;
export interface INasVolSnapshot extends TNasVolSnapshot {}
export const createNasVol = () => types.optional(NasVol, {} as TNasVol);
